import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchTasks = createAsyncThunk("tasks/fetch", async () => {
  const res = await api.get("/vendor/tasks");
  return res.data.tasks;
});

export const createTask = createAsyncThunk(
  "tasks/create",
  async (taskData) => {
    const res = await api.post("/vendor/tasks", taskData);
    return res.data.task;
  }
);

export const updateTask = createAsyncThunk(
  "tasks/update",
  async ({ id, ...data }) => {
    const res = await api.patch(`/vendor/tasks/${id}`, data);
    return res.data.task;
  }
);

export const deleteTask = createAsyncThunk("tasks/delete", async (id) => {
  await api.delete(`/vendor/tasks/${id}`);
  return id;
});

const tasksSlice = createSlice({
  name: "tasks",
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        const idx = state.items.findIndex((t) => t.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      })
      .addCase(deleteTask.fulfilled, (state, action) => {
        state.items = state.items.filter((t) => t.id !== action.payload);
      });
  },
});

export default tasksSlice.reducer;
